import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'help-book-demo',
    template: require('./help.book-demo.component.html'),
    styles: [require('../personal.account.shared.css'), require('./help.book-demo.component.css')]
})
export class HelpBookDemoComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('calendlyWidget', { static: false }) calendlyWidget: ElementRef;

    readonly calendlyUrl = 'https://calendly.com/renu-b2bquotetenders/demo?<strong>hide_gdpr_banner=1</strong>';
    private readonly calendlyScriptId = 'calendly-widget-script';

    ngOnInit() {
        document.body.classList.add('personal-account-fit');
    }

    ngAfterViewInit() {
        this.loadCalendlyScript().then(() => {
            this.initializeCalendlyWidget();
        });
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }

    private loadCalendlyScript(): Promise<void> {
        if ((window as any).Calendly) {
            return Promise.resolve();
        }

        const existingScript = document.getElementById(this.calendlyScriptId) as HTMLScriptElement;
        if (existingScript) {
            return new Promise<void>((resolve) => {
                existingScript.addEventListener('load', () => resolve());
            });
        }

        return new Promise<void>((resolve) => {
            const script = document.createElement('script');
            script.id = this.calendlyScriptId;
            script.type = 'text/javascript';
            script.src = 'https://assets.calendly.com/assets/external/widget.js';
            script.async = true;
            script.onload = () => resolve();

            document.body.appendChild(script);
        });
    }

    private initializeCalendlyWidget() {
        const calendly = (window as any).Calendly;
        if (!calendly || !this.calendlyWidget || !this.calendlyWidget.nativeElement) {
            return;
        }

        this.calendlyWidget.nativeElement.innerHTML = '';
        calendly.initInlineWidget({
            url: this.calendlyUrl,
            parentElement: this.calendlyWidget.nativeElement
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.book-demo.component.ts